<template>
  <div class="text-sm">
    <p class="mt-6"><b>2024.11.16</b> - Исправления ИИ, среди прочего</p>
  </div>
</template>
